import DeleteOutline from '@mui/icons-material/DeleteOutline';
import { Box, IconButton } from '@mui/material';
import { FC } from 'react';

import isNil from 'lodash/fp/isNil';

import AssignTO from '@components/DrawerContent/AssignmentList/components/AssignTo';
import Footer from '@components/DrawerContent/Footer';
import Title from '@components/DrawerContent/Title';

import { DrawerContentPropsSingleSelect } from '../../types';
import UsersList from '../UsersList';
import { useSingleSelectUsers } from './useSingleSelectUsers';

const SingleSelect: FC<DrawerContentPropsSingleSelect> = ({
  model,
  onClose,
  onSave,
  selected,
  additionalAllParams,
  title,
  filterOwner,
}) => {
  const { selectedUser, onUserClick, onDeleteUser } = useSingleSelectUsers({ selected });

  const onApplyClick = () => {
    onSave(selectedUser);
  };

  const isApplyDisabled = (isNil(selected) && isNil(selectedUser)) || selected?.id === selectedUser?.id;

  const DeleteIcon = () => (
    <IconButton edge="end" aria-label="delete" color="error" onClick={onDeleteUser}>
      <DeleteOutline />
    </IconButton>
  );

  return (
    <Box display="flex" flexDirection="column" flexGrow={1} bgcolor="common.white">
      <Title title={title || model || 'Recipient'} onClose={onClose} />

      <AssignTO user={selectedUser} rightAdornment={<DeleteIcon />} unassignedText={`No ${model} set`} />

      <UsersList
        filterOwner={filterOwner}
        isSelected={false}
        model={model}
        selectedUsers={selectedUser ? { [selectedUser.id]: selectedUser } : {}}
        onItemClick={onUserClick}
        filters={additionalAllParams}
        skipRequest={false}
        deletedUsers={{}}
      />

      <Footer handleSubmit={onApplyClick} title="Apply" sx={{ m: 2.5 }} disabled={isApplyDisabled} />
    </Box>
  );
};

export default SingleSelect;
